import { ifElse, propEq } from "ramda";
import { TEXT_LIST_COMPONENT_TYPE } from "../../../Manifest/modules/editableComponentTypes";
import { getMainDom } from "../../dataConnections/dataConnection.utils";
import { setNodeValue } from "../../xmlUtility";

/**
 * @param {DataSourceNode} parent - a dataSourceNode
 * @param {[DOMNode]} nodesToCheck - array of DOMNode
 * @returns {Promise} A promise for the completion of the operation
 */
function tryToInsertAsync(parent, nodesToCheck) {
    const currentCheckNode = nodesToCheck.pop();

    // Find child node of Parent with same name as CurrentCheckNode
    const matchingChild = parent.childNodes().filter((n) =>
        (n.localName() === currentCheckNode.localName) &&
        (n.namespaceURI() === currentCheckNode.namespaceURI)
    )[0];

    if (!matchingChild || nodesToCheck.length === 0) {
        //Insert CurrentCheckNode under Parent & we're done!
        const toInsert = currentCheckNode.cloneNode(true);

        return parent.appendChildAsync(toInsert);
    }

    return tryToInsertAsync(matchingChild, nodesToCheck); // Recurse down
}


function buildTryInsertList(container, innerFragment) {
    let currentNode = innerFragment;
    let nodesToCheck = [];

    if (currentNode) {
        while (currentNode && currentNode !== container) {
            nodesToCheck.push(currentNode);
            currentNode = currentNode.parentNode;
        }

        return nodesToCheck;
    } else {
        // Error
    }
}

const getListComponentContextAndNodes = (contextNode, editableComponent) => {
    const actualContext = contextNode.selectSingle(editableComponent.item);
    const itemToInsert = actualContext.selectSingle(editableComponent.element).getNode().cloneNode(true);
    setNodeValue(itemToInsert, '');
    const nodesToCheck = [itemToInsert];

    return [actualContext, nodesToCheck];
};

const getNonListContextAndNodes = (contextNode, editableComponent) => {
    // insert a new repeating row into the xmlDOM
    // (1) Select parent attribute from xsf:chooseFragment
    const pathToParent = editableComponent.parent;
    const actualContext = contextNode.selectSingle(pathToParent);
    const nodesToCheck = buildTryInsertList(editableComponent.fragmentContainer, editableComponent.getInnerFragment());

    return [actualContext, nodesToCheck];
};

// Not sure about the actual types here
// (ContextNode, EditableComponent) -> [ContextNode, [Node]]
const getActualContextAndNodesToCheck = ifElse(
    (_, editableComponent) => editableComponent.component === TEXT_LIST_COMPONENT_TYPE,
    getListComponentContextAndNodes,
    getNonListContextAndNodes,
);

function insertLastAsync(contextNode, editableComponent) {
    const [actualContext, nodesToCheck] = getActualContextAndNodesToCheck(contextNode, editableComponent);

    return tryToInsertAsync(actualContext, nodesToCheck);
}

const insertRowActionHandler = (getNodeForNodeId, viewManager, template, renderViewAsync) => {

    // xmlDOM - the XML DOM for the form
    // viewName - the name of the current view
    // sectionName - 
    // contextNode - an xml node near the repeating group (e.g. parent, grandparent)
    // insertType - type of insert (insertAfter, insertBefore, insert)
    async function insertRepeatingNodeAsync(viewName, sectionName, contextNode) {
        const editableComponent = template.getEditableComponent(viewName, sectionName);

        if (!editableComponent) {
            throw new Error('Could not determine item to insert.');
        }

        return insertLastAsync(contextNode, editableComponent);
    }

    // ViewEventInfo -> Promise[void]
    function handleInsertClickAsync({ id: nodeId, xmlToEdit }) {
        var contextNode = getNodeForNodeId(nodeId);

        // TODO - use the right DOM instead of the main one? maybe not needed because InfoPath only supports inserting into MDS

        return insertRepeatingNodeAsync(viewManager.getCurrentView(), xmlToEdit, contextNode)
            .then(renderViewAsync);
    }

    return {
        handleInsertClickAsync,
    };
};


export default insertRowActionHandler;